import { Box, css, keyframes, styled } from '@withjoy/joykit';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const AnimatedImageBox = styled(Box)<{ skipAnimation?: boolean }>`
  ${p =>
    p.skipAnimation
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
          animation: ${fadeIn} 0.5s ease-in forwards;
        `}
`;
